import React from 'react';
import { Link } from 'react-router-dom';
import './TreatmentPage.css';
import AdvancedRegenerative from '../assets/images/AdvancedRegenerative.png';
import PRPTherapy from '../assets/images/PRPTherapy.png';
import BMACTherapy from '../assets/images/BMACTherapy.png';
import StemCellTherapy from '../assets/images/StemCellTherapy.png';
import SpineInterventions from '../assets/images/SpineInterventions.png';   
import GeethaBhargavi   from '../assets/images/GeethaBhargavi.jpeg';


export default function PainMedicine() {
  return (
    <div>
      {/* HERO */}
      <section className="tx-hero" style={{backgroundImage:"url(https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?w=1400&q=80)"}}>
        <div className="tx-hero-overlay"/>
        <div className="container tx-hero-content">
          <div className="breadcrumb"><Link to="/">Home</Link><span className="sep">›</span><Link to="/treatments/pain-medicine">Treatments</Link><span className="sep">›</span><span>Pain Medicine</span></div>
          <span className="tx-hero-badge">Primary Focus</span>
          <h1>Regenerative Pain Medicine</h1>
          <p>Advanced biological therapies using your body's own healing power to eliminate chronic pain without surgery.</p>
          <div style={{display:'flex',gap:14,marginTop:28,flexWrap:'wrap'}}>
            <Link to="/contact" className="btn-acc">Book Consultation →</Link>
            <a href="#procedures" className="btn-ghost-w">View Procedures</a>
          </div>
        </div>
      </section>

      {/* INTRO */}
      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div className="intro-grid">
            <div>
              <div className="tag-line"><span>What We Offer</span></div>
              <h2 className="sec-title">Advanced Regenerative <span className="acc">Pain Treatments</span></h2>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:16}}>Our pain medicine division focuses on using your body's own biological resources to heal damaged tissue, reduce inflammation, and restore function — without the risks of major surgery or long-term medication dependency.</p>
              <p style={{fontSize:15.5,color:'#475569',lineHeight:1.8,marginBottom:28}}>These treatments are especially effective for patients above 45 who suffer from chronic joint pain, spine disorders, and degenerative conditions.</p>
              <div className="benefit-list">
                <div className="benefit-item"><span className="b-check">✓</span>No general anaesthesia required</div>
                <div className="benefit-item"><span className="b-check">✓</span>Same-day outpatient procedures</div>
                <div className="benefit-item"><span className="b-check">✓</span>Minimal recovery time</div>
                <div className="benefit-item"><span className="b-check">✓</span>Treats root cause, not symptoms</div>
                <div className="benefit-item"><span className="b-check">✓</span>Reduces need for surgery</div>
                <div className="benefit-item"><span className="b-check">✓</span>Long-lasting results</div>
              </div>
            </div>
            <div className="intro-img">
              <img src={AdvancedRegenerative} alt="Pain treatment consultation" style={{borderRadius:20,width:'100%',height:420,objectFit:'cover'}}/>
            </div>
          </div>
        </div>
      </section>

      {/* PROCEDURES */}
      <section id="procedures" className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:52}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Treatments</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Our Pain Medicine <span className="acc">Procedures</span></h2>
          </div>

          {/* PRP */}
          <div className="proc-row">
            <div className="proc-img"><img src={PRPTherapy} alt="PRP Therapy"/></div>
            <div className="proc-text">
              <div className="proc-num">01</div>
              <h3>PRP Therapy — Platelet-Rich Plasma</h3>
              <p>Platelet-Rich Plasma (PRP) therapy is one of the most effective regenerative treatments available. We draw a small amount of your blood, concentrate the platelets (which are rich in growth factors), and inject this concentrated plasma directly into the damaged joint or tissue.</p>
              <p style={{marginTop:12}}>PRP stimulates the body's natural healing response, accelerating tissue repair and reducing inflammation significantly.</p>
              <div className="proc-chips">
                <span>Knee Pain</span><span>Shoulder Pain</span><span>Tendinitis</span><span>Arthritis</span><span>Sports Injuries</span>
              </div>
            </div>
          </div>

          {/* BMAC */}
          <div className="proc-row reverse">
            <div className="proc-img"><img src={BMACTherapy} alt="BMAC Therapy"/></div>
            <div className="proc-text">
              <div className="proc-num">02</div>
              <h3>BMAC Therapy — Bone Marrow Aspirate Concentrate</h3>
              <p>BMAC therapy uses a concentrated extract of your own bone marrow, which contains a potent combination of mesenchymal stem cells, growth factors, and anti-inflammatory proteins. This concentrate is injected precisely into the injury site.</p>
              <p style={{marginTop:12}}>BMAC is particularly powerful for moderate-to-severe joint degeneration, cartilage damage, and conditions that haven't responded to PRP alone.</p>
              <div className="proc-chips">
                <span>Cartilage Damage</span><span>Severe Arthritis</span><span>Joint Degeneration</span><span>Chronic Pain</span>
              </div>
            </div>
          </div>

          {/* Stem Cell */}
          <div className="proc-row">
            <div className="proc-img"><img src={StemCellTherapy} alt="Stem Cell Therapy"/></div>
            <div className="proc-text">
              <div className="proc-num">03</div>
              <h3>Stem Cell Therapy</h3>
              <p>Stem cell therapy uses mesenchymal stem cells — your body's master healing cells — to regenerate damaged cartilage, tendons, ligaments, and connective tissue. Unlike medications that mask pain, stem cell therapy targets the underlying tissue damage itself.</p>
              <p style={{marginTop:12}}>This treatment is particularly effective for patients wishing to delay or avoid joint replacement surgery, offering a biological alternative with lasting results.</p>
              <div className="proc-chips">
                <span>Knee OA</span><span>Hip Pain</span><span>Cartilage Repair</span><span>Avoid Replacement</span>
              </div>
            </div>
          </div>

          {/* Spine */}
          <div className="proc-row reverse">
            <div className="proc-img"><img src={SpineInterventions} alt="Spine Interventions"/></div>
            <div className="proc-text">
              <div className="proc-num">04</div>
              <h3>Spine Interventions — Minimally Invasive</h3>
              <p>Our minimally invasive spine interventions provide targeted relief for disc herniation, nerve compression, facet joint pain, and sacroiliac disorders — without the risks of open spine surgery.</p>
              <p style={{marginTop:12}}>Using advanced imaging guidance, Dr. Geetha delivers precise injections and nerve blocks exactly where needed, providing rapid and lasting pain relief.</p>
              <div className="proc-chips">
                <span>Disc Herniation</span><span>Nerve Pain</span><span>Facet Joint Pain</span><span>SI Joint</span><span>Back Pain</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CONDITIONS */}
      <section className="section" style={{background:'#F8FAFC'}}>
        <div className="container">
          <div style={{textAlign:'center',marginBottom:44}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Conditions Treated</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Conditions We <span className="acc">Treat</span></h2>
          </div>
          <div className="cond-grid">
            {['Chronic Joint Pain','Back & Neck Pain','RSI (Repetitive Strain Injury)','Disc Herniation','Nerve Pain / Neuropathy','Osteoarthritis','Tendinitis / Tendinopathy','Sacroiliac Pain','Shoulder Pain','Hip Pain','Knee Pain','Bursitis','Frozen Shoulder','Plantar Fasciitis','Carpal Tunnel Syndrome','Fibromyalgia'].map(c=>(
              <div key={c} className="cond-chip">{c}</div>
            ))}
          </div>
        </div>
      </section>

      {/* DOCTOR */}
      <section className="section">
        <div className="container">
          <div style={{textAlign:'center',marginBottom:44}}>
            <div className="tag-line" style={{justifyContent:'center'}}><span>Your Specialist</span></div>
            <h2 className="sec-title" style={{textAlign:'center'}}>Meet Your <span className="acc">Pain Specialist</span></h2>
          </div>
          <div className="doc-strip">
            <div className="doc-strip-img"><img src={GeethaBhargavi} alt="Dr. Geetha Bhargavi"/></div>
            <div className="doc-strip-info">
              <h3>Dr. Geetha Bhargavi</h3>
              <p className="dsi-qual">MBBS, MD.Anaesth, FIPM</p>
              <p className="dsi-roles">Consultant Pain Physician · Interventional Spine Specialist · Regenerative Medicine Expert</p>
              <p className="dsi-bio">Dr. Geetha Bhargavi is Hyderabad's leading pain physician, specializing in regenerative medicine and interventional spine procedures. She has helped thousands of patients achieve lasting pain relief without surgery through precision-guided biological therapies.</p>
              <Link to="/doctors" className="btn-acc" style={{marginTop:16,display:'inline-flex'}}>Full Profile →</Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{background:'#0D4E9A',padding:'72px 0',textAlign:'center'}}>
        <div className="container">
          <h2 style={{fontSize:'clamp(26px,3vw,38px)',fontWeight:800,color:'#fff',marginBottom:16}}>Ready to Live Pain-Free?</h2>
          <p style={{fontSize:16,color:'rgba(255,255,255,0.78)',maxWidth:500,margin:'0 auto 32px'}}>Book a consultation with Dr. Geetha Bhargavi and get a personalised regenerative treatment plan.</p>
          <Link to="/contact" className="btn-acc" style={{fontSize:16,padding:'14px 32px'}}>Book Consultation →</Link>
        </div>
      </section>
    </div>
  );
}
